import { render, staticRenderFns } from "./OldModalWithSlot.vue?vue&type=template&id=63b39143&scoped=true"
import script from "./OldModalWithSlot.vue?vue&type=script&lang=js"
export * from "./OldModalWithSlot.vue?vue&type=script&lang=js"
import style0 from "./OldModalWithSlot.vue?vue&type=style&index=0&id=63b39143&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b39143",
  null
  
)

export default component.exports